import { render, staticRenderFns } from "./ChainInfo.vue?vue&type=template&id=7d864d65&scoped=true&"
import script from "./ChainInfo.vue?vue&type=script&lang=ts&"
export * from "./ChainInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ChainInfo.vue?vue&type=style&index=0&id=7d864d65&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d864d65",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QIcon,QTooltip});
